import { ComparedProduct } from 'b2b-common/core/product/api/ProductsCompare.types';
import {
  ADD_PRODUCT_TO_COMPARE,
  CLEAR_PRODUCTS_COMPARE,
  FETCH_PRODUCTS_COMPARE,
  FETCH_PRODUCTS_COMPARE_FULFILLED,
  FETCH_PRODUCTS_COMPARE_REJECTED,
  REMOVE_PRODUCT_FROM_COMPARE,
} from './actionTypes';
import {
  AddProductToCompareAction,
  ClearProductsCompareAction,
  FetchProductsCompareAction,
  FetchProductsCompareFulfilledAction,
  FetchProductsCompareRejectedAction,
  RemoveProductFromCompareAction,
} from './types';

export const fetchProductsCompare = (skus: string[]): FetchProductsCompareAction => ({
  type: FETCH_PRODUCTS_COMPARE,
  payload: {
    skus,
  },
});

export const fetchProductsCompareFulfilled = (
  data: ComparedProduct[],
): FetchProductsCompareFulfilledAction => ({
  type: FETCH_PRODUCTS_COMPARE_FULFILLED,
  payload: {
    data,
  },
});

export const fetchProductsCompareRejected = (
  error: ErrorType,
): FetchProductsCompareRejectedAction => ({
  type: FETCH_PRODUCTS_COMPARE_REJECTED,
  payload: {
    error,
  },
});

export const addProductToCompare = (
  sku: string,
): AddProductToCompareAction => ({
  type: ADD_PRODUCT_TO_COMPARE,
  payload: {
    sku,
  },
});

export const removeProductFromCompare = (
  sku: string,
): RemoveProductFromCompareAction => ({
  type: REMOVE_PRODUCT_FROM_COMPARE,
  payload: {
    sku,
  },
});

export const clearProductsCompare = (): ClearProductsCompareAction => ({
  type: CLEAR_PRODUCTS_COMPARE,
});
